import React from 'react';
import { ListProps } from 'react-admin';
import { IntegrationListPage } from '../Common/Integrations';
import webhookConfig from './config';

const WebhookList = (props: ListProps) => <IntegrationListPage config={webhookConfig} listProps={props} />;

export default WebhookList;
